/* eslint-disable  */

// ** Redux Imports
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { rankingAssistant } from "@api/Api";

export const getAllRankingAssistant = createAsyncThunk(
  "appRankingAssistant/getAllRankingAssistant",
  async (values) => {
    try {
      return rankingAssistant.getAll(values);
    } catch (error) {
      console.error(error);
    }
  }
);

export const appRankingAssistantSlice = createSlice({
  name: "appRankingAssistant",
  initialState: {
    rankingAssistant: [],
    rankingAssistantFetch: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllRankingAssistant.fulfilled, (state, action) => {
      state.rankingAssistant = action.payload?.data?.data;
      state.rankingAssistantFetch = true;
    });
  },
});

export default appRankingAssistantSlice.reducer;
